module.exports = __webpack_public_path__ + "img/title-1.9ab9f1ee.png";